export default __webpack_public_path__ + "static/media/commingSoonCalculator.9f8b5481.png";